import {
  Timestamp,
  collection,
  doc,
  getDocs,
  orderBy,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "../firebase/config";
import {
  ScheduledRecovery,
} from "../types/scheduledRecovery";

const toItem = (id: string, data: Record<string, unknown>): ScheduledRecovery => ({
  id,
  plannedDate: String(data.plannedDate || ""),
  modality: String(data.modality || ""),
  notes: String(data.notes || ""),
  ...(typeof data.linkedRecoveryLogID === "string" && data.linkedRecoveryLogID
    ? { linkedRecoveryLogID: data.linkedRecoveryLogID }
    : {}),
});

export const getScheduledRecoveries = async (
  userID: string,
  startDate: string,
  endDate: string,
): Promise<ScheduledRecovery[]> => {
  const snap = await getDocs(
    query(
      collection(db, "scheduledRecoveries", userID, "items"),
      where("plannedDate", ">=", startDate),
      where("plannedDate", "<=", endDate),
      orderBy("plannedDate", "asc"),
    ),
  );
  return snap.docs.map((item) =>
    toItem(item.id, item.data() as Record<string, unknown>),
  );
};

export const linkScheduledRecovery = async (
  userID: string,
  itemId: string,
  recoveryLogId: string,
): Promise<void> => {
  await updateDoc(doc(db, "scheduledRecoveries", userID, "items", itemId), {
    linkedRecoveryLogID: recoveryLogId,
    updatedAt: Timestamp.now(),
  });
};
